import React, {useEffect} from 'react'
import styled from 'styled-components'
import { Partners } from '../partners'
import { colors } from '../../styles/colors'

import block_1_pic from '../../img/wpupvxoVf4A1.jpg'
import { LinkButton } from '../UI/LinkButton'

const Container = styled.section`
`
const Block0 = styled.div`
    position: relative;
    overflow: hidden;

    @media (min-width: 960px) {
        padding: 31.25rem 20rem 20rem 20rem;
    }  
    @media (min-width: 768px) and (max-width: 959.98px) {
        padding: 31.25rem 7rem 20rem 6.75rem;
    }
    @media (max-width: 767.98px) {
        padding: 12.5rem 0rem;
    }

    // Included classes:

    .width-limiter {
        @media (min-width: 494px) and (max-width: 767.98px) {
            display: flex;
            flex-direction: column;
            align-items: center;    
        }    
    }

    .block-0_background-rectangle {
        position: absolute;
        z-index: -1;
        background: ${colors.dark_blue};
        transform: rotate(45deg);

        transition: all .5s;

        @media (min-width: 1920px) {
            height: 698px;

            right: -420px;
            top: -200px;
        }
        @media (min-width: 1440px) and (max-width: 1919.98px) {
            height: 598px;

            right: -430px;
            top: -160px;
        }
        
        @media (min-width: 960px) and (max-width: 1439.98px) {
            height: 598px;

            right: -530px;
            top: -260px;
        }
        @media (min-width: 960px) {
            width: 1194px;
        }
        @media (min-width: 768px) and (max-width: 959.98px) {
            width: 523px;
            height: 306px;
    
            right: -230px;
            top: -80px;
        }
    }

    .block-0_logo-block {
        max-width: 57.5rem;
        border: 1px solid ${colors.dark_blue};
        margin-bottom: 13.75rem;

        display: flex;
        flex-direction: column;
        align-items: center;

        @media (min-width: 494px) and (max-width: 767.98px) {
            width: 57.5rem;
        } 
    }
    
    .block-0_company-name {
        font-size: 8rem;
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        color: ${colors.dark_blue};    
        letter-spacing: .05rem;
    }

    .block-0_logo-description {
        max-width: 40rem;

        text-align: center;
        font-size: 2rem;
        font-weight: 300;
        letter-spacing: .1rem;

        background: ${colors.white};
        padding: 0 1rem;

        position: relative;
        top: 3.70rem;

        @media (max-width: 320px) {
            max-width: 27.75rem;
        }
    }

    .text {
        max-width: 940px;

        font-size: 3.75rem;
        line-height: 160%;
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        color: ${colors.dark_blue};
    
        .space {
            margin-left: 3.5rem;
        }

        @media (min-width: 321px) and (max-width: 1439.98px) {
            font-size: 3rem;
        }
        @media (max-width: 320px) {
            font-size: 2.25rem;
        }
    }    
`
const Block1 = styled.div`
    position: relative;
    overflow: hidden;

    padding: 8.75rem 2rem;
    border-top: 1px solid ${colors.dark_blue};

    display: flex;

    @media (min-width: 1920px) {
        padding: 8.75rem 2rem 19.25rem 2rem;
    }
    @media (min-width: 960px) {
        align-items: start;
        justify-content: center;
    }
    @media (min-width: 768px) and (max-width: 959.98px) {
        justify-content: flex-end;
    }

    // Included classes:

    .block-1_background-rectangle {
        background: ${colors.blue};
        transform: rotate(-45deg);

        position: absolute;
        z-index: -1;

        transition: all .5s;

        @media (min-width: 1920px) {
            left: -373px;
            top: -110px;  
        }
        @media (min-width: 1440px) and (max-width: 1919.98px) {
            left: -473px;
            top: -160px;  
        }
        @media (min-width: 1440px) {
            width: 995px;
            height: 538px;
        }
        @media (min-width: 768px) and (max-width: 1439.98px) {
            width: 495px;
            height: 268px;

            left: -173px;
            top: -60px;  
        }
    }

    .block-1_picture-base {

        transition: all .5s;

        @media (min-width: 1920px) {
            margin-right: 10rem;
        }
        @media (min-width: 1440px) and (max-width: 1919.98px) {
            margin-right: 5rem;
        }
        @media (min-width: 1440px) {
            width: 600px;
            height: 500px;
        }
        @media (min-width: 960px) and (max-width: 1439.98px) {
            width: 386px;
            height: 322px;
            margin-right: 3rem;
        }
        @media (min-width: 960px) {
            background: ${colors.dark_blue};
            box-shadow: -10px 10px 4px rgba(0, 0, 0, 0.1);
        }

        .block-1_picture {
            width: 100%;
            height: 100%;
    
            background: url(${block_1_pic}) no-repeat 50% 50%;
            background-size: cover;
            opacity: 1;
        }
    }

    .block-1_text-block {
        @media (min-width: 1920px) {
            max-width: 860px;
        }
        @media (min-width: 1440px) and (max-width: 1919.98px) {
            max-width: 620px;
        }
        @media (min-width: 768px) and (max-width: 1439.98px) {
            max-width: 410px;
        }
    }

    .block-1_title {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        line-height: 125%;
        color: ${colors.dark_blue};

        margin-bottom: 10rem;

        @media (min-width: 1920px) {
            font-size: 8rem;
        }
        @media (min-width: 321px) and (max-width: 1919.98px) {
            font-size: 4.5rem;
        }
        @media (max-width: 320px) {
            font-size: 3rem;
            margin-bottom: 8.75rem;
        }
    }
    .text {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        line-height: 160%;
        color: ${colors.dark_blue};            

        @media (min-width: 1440px) {
            font-size: 3.75rem;
        }
        @media (min-width: 321px) and (max-width: 1439.98px) {
            font-size: 3rem;
        }
        @media (min-width: 321px) {
            .space { margin-left: 2.25rem }
        }
        @media (max-width: 320px) {
            font-size: 2.25rem;
        }
    }
`
const Block2 = styled.div`
    border-top: 1px solid ${colors.dark_blue};

    // Included classes:

    .width-limiter {
        padding: 7.5rem 2rem 13.75rem 2rem;
        display: flex;

        @media (min-width: 1440px) and (max-width: 1919.98px) {
            padding: 7.5rem 11.25rem 13.75rem 11.25rem;
        }      
        @media (min-width: 960px) and (max-width: 1439.98px) {
            padding: 7.5rem 11.25rem 5rem 11.25rem;
        }      
        @media (min-width: 768px) and (max-width: 959.98px) {
            padding: 4.25rem 9.25rem;
        }      
        @media (min-width: 321px) and (max-width: 1439.98px) {
            flex-direction: column;
        }      
        @media (max-width: 767.98px) {
            padding: 6.25rem 2rem 5rem 2rem;
        }    
    }

    .text {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        line-height: 160%;
        font-size: 3.75rem;
        color: ${colors.dark_blue};

        @media (min-width: 768px) and (max-width: 1439.98px) {
            margin-bottom: 2.25rem;
            font-size: 3rem;
        }
        @media (max-width: 320px) {
            font-size: 2.25rem;
        }         

        .space {
            margin-left: 3.5rem;
        }
    }
    .link-button {
        @media (min-width: 768px) {
            align-self: flex-end;
        }
        @media (max-width: 767.98px) {
            display: none;
        }
    }
`
const Block3 = styled.div`
`

export const Home = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Container>
            <Block0 className="block-0">
                <div className="block-0_background-rectangle" />
                <div className='width-limiter'>
                    <div className="block-0_logo-block">
                        <span className="block-0_company-name">Флагман</span>
                        <div className="block-0_logo-description">ОФИЦИАЛЬНЫЙ ДИЛЕР <br /> СПЕЦТЕХНИКИ, ОБОРУДОВАНИЯ <br /> И ЗАПЧАСТЕЙ</div>
                    </div>
                    <div>
                        <p className="text"><span className='space' /> Компания Флагман ведет свою успешную деятельность с 2000 года.</p>
                        <p className="text"><span className='space' /> С каждым годом поток клиентов и партнеров увеличивается. Флагман является представителем лидирующих компаний на рынке спецтехники и оборудования. С нами сотрудничают такие компании как Бецема, Техлайн, HYVA, Camozzi и Binotto.</p>
                    </div>
                </div>
            </Block0>

            <Block1 className="block-1">

                <div className="block-1_background-rectangle" />

                <div className="block-1_picture-base">
                    <div className="block-1_picture" />
                </div>

                <div className="block-1_text-block">
                    <h2 className="block-1_title">Более 20 лет на рынкe выбирают нас!</h2>
                    <div>
                        <p className="text"><span className='space' /> Нас выбирают, потому что мы:</p> <br />
                        <p className="text"> -  Находим индивидуальный подход к каждому клиенту.</p>
                        <p className="text"> -  Помогаем провести все необходимые расчеты.</p>
                        <p className="text"> -  Своевременно отвечаем на все возникшие вопросы.</p>
                        <p className="text"> -  Ручаемся за качество, износостойкость <br /> и технологичность продукции и услуг.</p>
                    </div>
                </div>
                   
            </Block1>

            <Block2 className="block-2">
                <div className="width-limiter">

                    <div>
                        <p className='text'><span className='space' />Основным профилем нашей компании является поставка технологического оборудования и всего спектра запчастей по наличию со склада производства ЗАО "БЕЦЕМА".</p> <br />
                        <p className='text'><span className='space' />Мы предоставляем весь каталог продукции, автотранспорта и перечень сервисного обслуживания, который указан на официальных сайтах наших партнеров.</p>
                    </div>

                    <LinkButton link='/products' text='Перейти к продукции' />
                </div>
            </Block2>

            <Block3 className="block-3">
                <Partners />
            </Block3>

        </Container>
    )
}
